import React from 'react';
import { useTranslation } from 'react-i18next';

export function LanguageSelector() {
  const { i18n } = useTranslation();

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => i18n.changeLanguage('it')}
        className={`flex items-center space-x-1 px-2 py-1 rounded ${
          i18n.language === 'it' ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'
        }`}
      >
        <img
          src="https://flagcdn.com/w20/it.png"
          width="20"
          height="15"
          alt="Italian"
          className="rounded"
        />
        <span className="text-sm">IT</span>
      </button>
      <button
        onClick={() => i18n.changeLanguage('en')}
        className={`flex items-center space-x-1 px-2 py-1 rounded ${
          i18n.language === 'en' ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'
        }`}
      >
        <img
          src="https://flagcdn.com/w20/gb.png"
          width="20"
          height="15"
          alt="English"
          className="rounded"
        />
        <span className="text-sm">EN</span>
      </button>
    </div>
  );
}